export class Logger {
  static log = (...params: any): void => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(...params)
    }
  }
}
